import { gql } from "@apollo/client";

const UPDATE_ASIGNACION_PROFESIONAL = gql`
    mutation updateAsignacionProfesional($input: UpdateAsignacionProfesionalInput!){
        updateAsignacionProfesional(input: $input) {
        success
        error
        valorEsperado {
            idEvaluacionProfesional            
            }            
        }
    }
`;

export default UPDATE_ASIGNACION_PROFESIONAL;